const MEMBER_TOKEN_KEY = "memberToken";
const MEMBER_IDENTITY_KEY = "memberIdentity";
const MEMBER_DEVICE_KEY = "memberDeviceId";

export const MEMBER_APP_VERSION = "1.10";

export function getMemberDeviceId() {
  let deviceId = localStorage.getItem(MEMBER_DEVICE_KEY);
  if (!deviceId) {
    deviceId = `web-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(MEMBER_DEVICE_KEY, deviceId);
  }
  return deviceId;
}

export function getMemberToken() {
  return localStorage.getItem(MEMBER_TOKEN_KEY);
}

export function getMemberIdentity() {
  try {
    return JSON.parse(localStorage.getItem(MEMBER_IDENTITY_KEY) || "null");
  } catch (err) {
    return null;
  }
}

export function setMemberSession(data) {
  localStorage.setItem(MEMBER_TOKEN_KEY, data.token);
  localStorage.setItem(MEMBER_IDENTITY_KEY, JSON.stringify(data));
}

export function clearMemberSession() {
  localStorage.removeItem(MEMBER_TOKEN_KEY);
  localStorage.removeItem(MEMBER_IDENTITY_KEY);
}

